
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import TextField from '@/components/shared/TextField.vue';
import '@/validation-rules';

@Component<PromptLocaleEditor>({
	components: {
		TextField,
		ValidationProvider
	}
})
export default class PromptLocaleEditor extends Vue {
	@Prop({ type: Object, default: () => ({}) }) private prompt!: RallyIntelligencePromptRequest;
	@Prop({ type: Object, default: null }) private selectedLocale!: RestaurantLocale | null;

	@Watch('selectedLocale')
	private onSelectedLocaleUpdate(): void {
		if (this.selectedLocale && !this.selectedLocale.is_default) {
			this.mutablePrompt.localization = this.mutablePrompt.localization ? this.mutablePrompt.localization : {} as { [key: string]: LocalizationInfo };
			if (!this.mutablePrompt.localization[this.selectedLocale.locale_short]) {
				this.$set(this.mutablePrompt.localization, this.selectedLocale.locale_short, {
					name: '',
					description: '',
					content: ''
				});
			}
		}
	}

	private mutablePrompt: RallyIntelligencePromptRequest = this.prompt;

	private get anyFilled(): boolean {
		if (!this.selectedLocale || this.selectedLocale.is_default) {
			return false;
		}
		const entry = this.mutablePrompt.localization?.[this.selectedLocale.locale_short];
		if (!entry) {
			return false;
		}
		return !!(entry.name?.trim() || entry.description?.trim() || entry.content?.trim());
	}
}
